export * from './ubiLayoutListDetail.component';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiLayoutListDetail/index.ts